import type { EstadoTrabajo, Operacion } from '@laser/core';

export const ESTADOS: EstadoTrabajo[] = [
  'recibido', 'en_revision', 'cotizado', 'pagado', 'en_cola', 'cortando', 'listo', 'entregado', 'cancelado',
];

export const ETIQUETA_ESTADO: Record<EstadoTrabajo, string> = {
  recibido: 'Recibido',
  en_revision: 'En revisión',
  cotizado: 'Cotizado',
  pagado: 'Pagado',
  en_cola: 'En cola',
  cortando: 'Cortando',
  listo: 'Listo',
  entregado: 'Entregado',
  cancelado: 'Cancelado',
};

/** Estados que siguen ocupando al taller (para contadores y programa). */
export const ESTADOS_ACTIVOS: EstadoTrabajo[] = ['recibido', 'en_revision', 'cotizado', 'pagado', 'en_cola', 'cortando', 'listo'];

/** Siguientes pasos naturales; el admin puede forzar cualquier estado desde el selector. */
export const SIGUIENTES: Record<EstadoTrabajo, { a: EstadoTrabajo; texto: string }[]> = {
  recibido: [{ a: 'en_revision', texto: 'Empezar revisión' }],
  en_revision: [],
  cotizado: [{ a: 'pagado', texto: 'Marcar pagado' }, { a: 'en_revision', texto: 'Regresar a revisión' }],
  pagado: [{ a: 'en_cola', texto: 'Mandar a la cola' }],
  en_cola: [{ a: 'cortando', texto: 'Empezar a cortar' }],
  cortando: [{ a: 'listo', texto: 'Marcar listo' }, { a: 'en_cola', texto: 'Regresar a la cola' }],
  listo: [{ a: 'entregado', texto: 'Marcar entregado' }],
  entregado: [],
  cancelado: [{ a: 'recibido', texto: 'Reabrir' }],
};

/** Se puede aprobar (mandar link de pago) mientras no se haya cobrado. */
export const puedeAprobar = (e: EstadoTrabajo) => e === 'recibido' || e === 'en_revision' || e === 'cotizado';
/** Se puede recotizar antes de cortar. */
export const puedeRecotizar = (e: EstadoTrabajo) => e === 'recibido' || e === 'en_revision' || e === 'cotizado' || e === 'pagado' || e === 'en_cola';

export const ETIQUETA_OPERACION: Record<Operacion, string> = {
  corte: 'Corte', marcado: 'Marcado', grabado: 'Grabado', ignorar: 'Ignorar',
};

export const OPERACIONES: Operacion[] = ['corte', 'marcado', 'grabado', 'ignorar'];
